import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { BookForm } from './components/BookForm';
import { BookViewer } from './components/BookViewer';
import { PrivateRoute } from './components/PrivateRoute';
import { AdminSection } from './components/AdminSection';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Set loaded after initial render
    setIsLoaded(true);
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminSection /></PrivateRoute>} />
          <Route path="/new-book" element={<PrivateRoute><BookForm /></PrivateRoute>} />
          <Route path="/books/:bookId" element={<PrivateRoute><BookViewer /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;